import { FC } from 'react';
import { Link } from 'react-router-dom';
import { path } from '@/routes/Routes.helpers';
import { authApi } from '@/api/authApi/authApi';
import AvatarIcon from '@/components/elems/LinkToProfile/AvatarIcon/AvatarIcon.component';
import styles from '@/components/elems/LinkToProfile/LinkToProfile.module.scss';
import { LinkToProfilePropsIF } from '@/components/elems/LinkToProfile/LinkToProfile.types';

const LinkToProfile: FC<LinkToProfilePropsIF> = ({ isNeedHighlight }) => {
    const { data: currentUser } = authApi.useGetCurrentUserQuery();

    const avatar = currentUser?.avatarGuid ?? null;

    if (currentUser) {
        return (
            <>
                <Link
                    className={`${styles.linkToProfileWrapper} ${isNeedHighlight ? 'tourStepAvatar' : ''}`}
                    to={path('profile')}
                >
                    <AvatarIcon avatar={avatar} />
                </Link>
            </>
        );
    }
};

export default LinkToProfile;
